import PinDropIcon from '@mui/icons-material/PinDrop';
import TodayIcon from '@mui/icons-material/Today';

import { redirectToG500LiteCarInfoPage } from '../../common/utils/redirectToG500Lite';
import { redirectToOffsegDailyReportPage } from '../../common/utils/redirectToOffseg';
import { MenuItemListType } from '../../common/type/MenuItemListType';

export const pageName = '車両利用実績一覧';

export const searchType = {
	car: 1,
	driver: 2,
} as const;

export const tableColumnList = [
	{ id: 'startDatetime', label: '運行開始日', minWidth: 50 },
	{ id: 'endDatetime', label: '運行終了日', minWidth: 50 },
	{ id: 'organizationName', label: '組織(車両)', minWidth: 120 },
	{ id: 'carCode', label: '車両番号', minWidth: 70 },
	{ id: 'numberPlate', label: 'ナンバープレート', minWidth: 90 },
	{ id: 'driverName', label: 'ドライバー名', minWidth: 100 },
	{ id: 'model', label: 'モデル', minWidth: 50 },
];

export const offsegMenuItemList: MenuItemListType = [
	{
		value: 'ドライバー/車両日報',
		name: 'ドライバー/車両日報',
		onClick: redirectToOffsegDailyReportPage,
		icon: TodayIcon,
	},
];

export const g500LiteMenuItemList: MenuItemListType = [
	{
		value: '車両情報をみる',
		name: '車両情報をみる',
		onClick: redirectToG500LiteCarInfoPage,
		icon: PinDropIcon,
	},
];

export const resultNumLable = {
	title: '実績件数',
	offseg: 'Offseg：',
	g500Lite: 'G500Lite：',
	sum: '合計：',
	unit: '件',
};
